module.exports = __webpack_public_path__ + "img/dp-jy-qt2.221d0b58.png";